'use client';

import Script from 'next/script';

type OwnProps = {
  disableGTM?: boolean;
  gtmId: string;
  isNative: boolean;
};

export default function GoogleTagManager({
  disableGTM,
  gtmId,
  isNative
}: OwnProps) {
  const includeGTM = Boolean(gtmId && !isNative && !disableGTM);

  return includeGTM ? (
    <>
      <Script
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html: `
window.dataLayer = window.dataLayer || [];
window.dataLayer.push({
  'gtm.start': new Date().getTime(),
  event: 'gtm.js'
});
`
        }}
      />

      <Script
        defer
        src={`https://www.googletagmanager.com/gtm.js?id=${gtmId}`}
        strategy="afterInteractive"
      />
    </>
  ) : null;
}
